import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { filterCountries } from '../../../../helpers/select/filterCountries';
import { getCurrentLangPretty } from '../../../../helpers/url/urlHelpers';
import useCountries from '../../../../hooks/useCountries';
import usePostCodes from '../../../../hooks/usePostCodes';
import { ReactComponent as IconIceland } from '../../../../icons/iceland.svg';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import FormikSelect from '../../../base/forms/formikSelect';
import { Column, Columns } from '../../../base/grid';
import Error from '../../../error';
import { RawLoader } from '../../../loading/loading';
import { countriesSelectStyles } from '../../../registerShipment/registerShipmentForm/stepType/stepType.styles';
import { IRegisterShipmentCalculator } from '../../registerShipmentCalculator.schema';
import * as StyledForm from '../calcForm.styles';

interface Props {
	values: IRegisterShipmentCalculator;
	isIcelandSelected: boolean;
	setFieldTouched: any;
	setFieldValue: any;
}

const CalcCountrySelection: FC<Props> = ({ values, isIcelandSelected, setFieldTouched, setFieldValue }) => {
	const { t } = useTranslation('registerShipment');
	const lang = getCurrentLangPretty();
	const { countries, countriesError, countriesLoading } = useCountries(lang);
	const { postCodes, postCodesLoading, postCodesError } = usePostCodes();

	if (countriesLoading && postCodesLoading) return <RawLoader />;

	if (postCodesError || countriesError) return <Error />;

	return (
		<StyledForm.CountrySelectWrapper>
			<Columns>
				<Column tablet={1 / 2}>
					<FormikFieldWrapper
						marginBottom="1.5rem"
						label={`${t('step-type.where-are-you-delivering-to')}?`}
						name="country"
						languageComponent="registerShipment">
						<FormikSelect
							id="country"
							name="country"
							value={values.country}
							options={countries}
							onBlur={setFieldTouched}
							styles={countriesSelectStyles}
							onChange={setFieldValue}
							searchFunction={filterCountries}
						/>
					</FormikFieldWrapper>
				</Column>
				<StyledForm.ImgColumn tablet={1 / 2}>
					<StyledForm.ShipmentLocationFigure>
						{isIcelandSelected ? (
							<IconIceland />
						) : (
							<StyledForm.IconWorldImg src="/dist/icons/world.svg" alt="Earth" />
						)}
					</StyledForm.ShipmentLocationFigure>
				</StyledForm.ImgColumn>
			</Columns>
			{isIcelandSelected && (
				<Columns>
					<Column tablet={1 / 2}>
						<FormikFieldWrapper
							marginBottom="1.5rem"
							label={`${t('step-type.delivering-from')}*`}
							name="fromPostalCode"
							languageComponent="registerShipment">
							<FormikSelect
								id="fromPostalCode"
								name="fromPostalCode"
								value={values.fromPostalCode}
								options={postCodes}
								placeholder={t('step-type.choose-zip-code')}
								onBlur={setFieldTouched}
								onChange={setFieldValue}
							/>
						</FormikFieldWrapper>
					</Column>

					<Column tablet={1 / 2}>
						<FormikFieldWrapper
							marginBottom="1.5rem"
							label={`${t('step-type.delivering-to')}*`}
							name="toPostalCode"
							languageComponent="registerShipment">
							<FormikSelect
								id="toPostalCode"
								name="toPostalCode"
								value={values.toPostalCode}
								options={postCodes}
								placeholder={t('step-type.choose-zip-code')}
								onBlur={setFieldTouched}
								onChange={setFieldValue}
							/>
						</FormikFieldWrapper>
					</Column>
				</Columns>
			)}
		</StyledForm.CountrySelectWrapper>
	);
};

export default CalcCountrySelection;
